<ng-container *ngIf="(passwordValidated$ | async) === false && hasAccountMinProspect; else editPhone">
  <app-profile-validate-password
    [validatePasswordLoading]="loading$ | async"
    (cancelValidate)="onCancel()"
    (validatePassword)="onValidatePassword($event)"
  >
  </app-profile-validate-password>
</ng-container>
<ng-template #editPhone>
  <h3 class="ui-headline">{{ 'account.summary.section.mobilePhone' | translate }}</h3>
  <ng-container *ngIf="(validatePhone$ | async) === false">
    <form [formGroup]="mobilePhoneForm" #mobilePhoneDirective="ngForm" (ngSubmit)="onUpdateMobilePhone()">
      <div class="input-box personal-details-phone" [class.only-ch]="chCustomer">
        <label for="phone">{{ 'account.summary.section.mobilePhone' | translate }}</label>
        <ngx-intl-tel-input
          [selectedCountryISO]="inputOptions.initialCountry"
          [preferredCountries]="inputOptions.preferredCountries"
          [separateDialCode]="inputOptions.separateDialCode"
          [onlyCountries]="inputOptions.onlyCountries"
          [phoneValidation]="true"
          [customPlaceholder]="mobilePhonePlaceholder"
          (countryChange)="onCountryChange($event)"
          id="phone"
          formControlName="phone"
        />
        <p class="error empty" *ngIf="mobilePhoneDirective.submitted && mobilePhoneControl.hasError('required')">
          {{ 'desktop_error.account.personal-information.error.phoneEmpty' | translate }}
        </p>
        <p
          class="error empty"
          *ngIf="mobilePhoneDirective.submitted && !mobilePhoneControl.hasError('required') && mobilePhoneControl.invalid"
        >
          {{ 'profile.personalDetails.error.phoneNumber.format' | translate }}
        </p>
      </div>
      <!--/.input-box-->
      <div class="ui-button-group">
        <button type="submit" class="ui-button" [class.loading]="loading$ | async">
          <span class="icon-i-windmill"></span>
          {{ has3AAccountMinProspect ? ('general.next' | translate) : ('personal.send' | translate) }}
        </button>
        <button (click)="onCancel()" class="ui-button-text">
          <span>{{ 'modals.consultation.cta.cancel' | translate }}</span>
        </button>
      </div>
    </form>
  </ng-container>
  <ng-container *ngIf="validatePhone$ | async">
    <form [formGroup]="mobileValidateForm">
      <p>
        {{ 'account.mobilePhoneValidation.warning' | translate }}
      </p>
      <p>
        {{ 'account.mobilePhoneValidation.label' | translate: { phoneNumber: '' } }}
        <a (click)="resetOtpValidation()">{{ phoneNumber | formatPhone }}</a>
      </p>
      <div class="input-box profile-phone-verify">
        <app-profile-otp-code formControlName="code"></app-profile-otp-code>
        <p *ngIf="showValidationError" class="error empty">
          {{ 'account.mobilePhoneValidation.error' | translate }}
        </p>
      </div>
      <div class="input-box txt-center">
        <a (click)="onResendCode()">{{ 'account.mobilePhoneValidation.ctaResend' | translate }}</a>
      </div>
      <p class="profile-phone-disclaimer">
        {{ 'account.mobilePhoneValidation.contact.p1' | translate }}
        <a routerLink="/help">{{ 'account.mobilePhoneValidation.contact.p2' | translate }}</a>
      </p>
    </form>
  </ng-container>
</ng-template>
